import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../../records/grids";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import { Record } from "../../../../records/server/crud";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../app/records/server/serverUtility";

import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";
import "angular-formly";
const gridId = Symbol("main.contract.machine.edit.grid");
export class MachinesEditController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    RecordGridViewServiceName,
    "$compile",
  ];

  contractMachinesOnly: boolean = true;
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  initialMachineIds: number[] = [];
  readonly contract: any;
  contractMachineIds: any[] = [];

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly recordGridViewService: RecordGridViewService,
    $compile: ICompileService
  ) {
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/machines/machine"
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
    const gridConfiguration: GridConfiguration | undefined =
      this.recordGridViewService.getGridConfiguration("machine");
    if (!gridConfiguration) {
      throw new Error(
        "Must have machineConfiguration registered with recordGridViewService"
      );
    }
    this.columns = [
      {
        colId: "select",
        headerName: "Select",
        template: `
          <input
            type="checkbox"
            ng-click="recordGridController.toggleRowSelection(data)"
            ng-checked="recordGridController.rowSelected(data)"
          />`,
        suppressSorting: true,
      },
      ...(gridConfiguration?.columns ?? []),
    ];
  }

  $onInit(): void {
    this.initialMachineIds = [...this.contractMachineIds];
    this.defaultQuery.Ids = this.initialMachineIds;
  }

  gridSelectionChanged(
    row: Record,
    selected: boolean,
    gridSelection: number[]
  ) {
    this.initialMachineIds = gridSelection;
    const machineId = <number>row.Id;
    if (selected) {
      this.addMachineToContract(machineId);
    } else {
      this.removeMachineToContract(machineId);
    }
  }

  contractMachinesOnlyChanged(contractMachinesOnly: boolean) {
    this.defaultQuery.Ids = contractMachinesOnly
      ? this.initialMachineIds
      : undefined;
  }

  private addMachineToContract(machineId: number) {
    this.serverUtility
      .sendApiRequest({
        method: "post",
        url: `api/contract/contractMachines/${this.contract.Id}`,
        data: {
          MachineId: machineId,
        },
      })
      .then((r) => {});
  }

  private removeMachineToContract(machineId: number) {
    this.serverUtility
      .sendApiRequest({
        method: "delete",
        url: `api/contract/contractMachines`,
        data: {
          ContractId: this.contract.Id,
          MachineId: machineId,
        },
      })
      .then((r) => {});
  }
}
